import "./App.css";
import "./styles/custom-bootstrap.scss";
// import "bootstrap/dist/js/bootstrap.bundle.min";
// import "bootstrap/dist/js/bootstrap.js";
import { Navbar } from "./Navigation/Navbar";
import { Footer } from "./Navigation/Footer";
import { HomePage } from "./Body/HomePage";
import { Redirect, Route, Switch } from "react-router-dom";
import ScrollToTop from "./Navigation/ScrollToTop";
import { RightNoteBody } from "./RightNote/components/RightNoteBody";
import { DiffrentiaBody } from "./Diffrentia/Components/DiffrentiaBody";
import { DaveUI } from "./Dave/DaveUI";
import { AboutBody } from "./about/AboutBody";

function App() {
    return (
        <div>
            <ScrollToTop />
            <Navbar />
            <Switch>
                <Route path="/" exact>
                    <Redirect to="/home" />
                </Route>
                <Route path="/home">
                    <HomePage />
                </Route>
                <Route path="/hittingtherightnote">
                    <RightNoteBody />
                </Route>
                <Route path="/diffrentia">
                    <DiffrentiaBody />
                </Route>
                <Route path="/davesday">
                    <DaveUI />
                </Route>
                <Route path="/about">
                    <AboutBody />
                </Route>
            </Switch>
            <Footer />
        </div>
    );
}

export default App;
